import {
  intrigueCardsDefRepository,
  ResourceType,
  TurnPhase,
} from "~/business";
import {
  XButton,
  XIntrigueCard,
  XPlayerIcon,
  XResourceWithAmount,
  XTechTile,
  XTypography,
} from "~/jsx/components/design";
import { ModalNames } from "~/jsx/context/ModalNames";
import { Sizes } from "~/jsx/theme";
import { ordinal } from "~/utils";
import { XDesignModal } from "../design/XDesignModal";
import { useGame } from "~/app";

export const XEndGameModal = () => {
  const { game } = useGame();
  const { turnPhase, gamePodium } = game;

  return (
    <XDesignModal
      name={ModalNames.endGame}
      visible={turnPhase === TurnPhase.EndGame}
      title="The game has ended"
    >
      {gamePodium.map((player, index) => {
        const place = ordinal(index + 1);
        const endGameIntrigueCards = player.intrigueCards.pile.filter((card) =>
          card
            .getDef(intrigueCardsDefRepository)
            .phaseEffects.some(({ phase }) => phase === TurnPhase.EndGame)
        );
        const endGameTechs = player.techTiles.pile.filter((tech) =>
          tech.effects.some((effect) => effect.phase === TurnPhase.EndGame)
        );
        return (
          <div key={player.id} style={{ marginTop: 32 }}>
            <XTypography>
              <span>{place}:</span>
              <XPlayerIcon playerId={player.id} width={18} /> {player.name}
              <div style={{ display: "inline-block", marginLeft: 10 }}>
                <div style={{ display: "flex", gap: 10 }}>
                  <XResourceWithAmount
                    type="victory"
                    amount={player.totalVictoryPoints}
                    width={18}
                    variant="separated"
                  />
                  {[
                    ResourceType.Spice,
                    ResourceType.Solaris,
                    ResourceType.Water,
                  ].map((resourceType) => (
                    <XResourceWithAmount
                      key={resourceType}
                      type={resourceType}
                      amount={player.getResource(resourceType)}
                      width={18}
                      variant="separated"
                    />
                  ))}
                  <XResourceWithAmount
                    type="troop"
                    amount={player.garnisonTroops.length}
                    width={18}
                    variant="separated"
                  />
                </div>
              </div>
            </XTypography>
            <div style={{ display: "flex", gap: 10 }}>
              {endGameIntrigueCards.map((intrigueCard) => (
                <XIntrigueCard
                  key={intrigueCard.id}
                  width={Sizes.intrigueCard.width}
                  card={intrigueCard}
                />
              ))}
              {endGameTechs.map((tech) => (
                <XTechTile key={tech.id} techTile={tech} />
              ))}
            </div>
          </div>
        );
      })}
      <XButton
        style={{ margin: "auto", width: "fit-content", marginTop: 32 }}
        variant="action"
        onClick={() => {
          window.location.pathname = "/";
        }}
      >
        Leave
      </XButton>
    </XDesignModal>
  );
};
